// src/Models/ticketMandatoryFieldModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class TicketMandatoryFieldModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      mandatoryFieldID: data.mandatoryFieldId || data.mandatoryFieldID,
      projectID: data.projectId || data.projectID,
      statusID: data.statusId || data.statusID,
      fieldName: data.fieldName,
      isMandatoryFlag: data.isMandatoryFlag !== undefined ? data.isMandatoryFlag : false,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      mandatoryFieldId: Number(data.mandatoryFieldID || data.mandatoryFieldId || 0),
      projectId: Number(data.projectID || data.projectId || 0),
      statusId: Number(data.statusID || data.statusId || 0),
      fieldName: data.fieldName || '',
      isMandatoryFlag: data.isMandatoryFlag === true || data.isMandatoryFlag === 'true',
    };
  }
}
